<div class="bg-white p-1 border-circle border-1 border-blue-200 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer" (click)="openRightPanel(tempRef)">{{username()[0] | uppercase}}</div>
<ng-template #tempRef>
  <app-sidenav [title]="'profilo'">
    <div class="flex flex-column gap-3 align-items-center">
      <div class="bg-white p-1 border-circle border-1 border-blue-200 w-6rem h-6rem flex align-items-center justify-content-center text-4xl">{{username()[0] | uppercase}}</div>
      <span cdkFocusRegionstart class="text-xl">{{username() |titlecase}}</span>
      <div class="flex flex-column w-full">
        <div class="flex w-full justify-content-between mb-2">
          <span class="font-light">e-mail</span>
          <span>{{email()}}</span>
        </div>
        <div class="flex w-full justify-content-between  mb-2">
          <span class="font-light">registrato dal</span>
          <span>{{createdAt() | date:'dd/MM/yyyy HH:mm'}}</span>
        </div>
        <div class="flex w-full justify-content-between  mb-2 gap-5" *ngIf="isSetRole()">
          <span class="font-light col-6">Ruoli</span>
          <app-role-select class="col-5"></app-role-select>
        </div>
      </div>
   <!--    <app-change-password></app-change-password> -->
    </div>
    <div footer>
      <div class="flex justify-content-center">
        <app-logout [logoutCallback]="onLogoutClick.bind(this)" class="w-full"></app-logout>
      </div>
    </div>
  </app-sidenav>
</ng-template>

